import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import './CauseAndEffectEditorComponent.scss';
import CauseAndEffectEditorCard from './CauseAndEffectEditorCard';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const SECTION_IMAGE = 'image';

const defaultProps = {
  causeCard: { key: 0 },
  effectCard: { key: 0 },
  isSelected: false,
  isCauseSelected: true,
  selectedSection: SECTION_IMAGE,
  onImageSelected: () => { },
  onTextSelected: () => { },
  onAudioSelected: () => { },
};

export default function CauseAndEffectEditorComponent(p) {
  const {
    causeCard,
    effectCard,
    isSelected,
    isCauseSelected,
    selectedSection,
    onImageSelected,
    onTextSelected,
    onAudioSelected,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='cause-and-effect-editor-component vizzle-cause-and-effect-editor'>
      <div className='card-container'>
        <CauseAndEffectEditorCard
          card={causeCard}
          onImageSelected={(section) => onImageSelected({ isCauseSelected: true, selectedSection: section })}
          onTextSelected={(section) => onTextSelected({ isCauseSelected: true, selectedSection: section })}
          onAudioSelected={(section) => onAudioSelected({ isCauseSelected: true, selectedSection: section })}
          isSelected={isSelected && isCauseSelected}
          selectedSection={selectedSection}
        />
      </div>
      <div>
        <DoubleArrowIcon className='arrow' />
      </div>
      <div className='card-container'>
        <CauseAndEffectEditorCard
          card={effectCard}
          onImageSelected={(section) => onImageSelected({ isCauseSelected: false, selectedSection: section })}
          onTextSelected={(section) => onTextSelected({ isCauseSelected: false, selectedSection: section })}
          onAudioSelected={(section) => onAudioSelected({ isCauseSelected: false, selectedSection: section })}
          isSelected={isSelected && !isCauseSelected}
          selectedSection={selectedSection}
        />
      </div>
    </div>
  );
}
